var Maps = function() {
    var Maps = {
        pollingLocation: {}
    };
    Maps.pollingLocation = {
        $pollingLocationMap: null,
        $pollingLocationDirectionsPanel: null,
        startAddress: null,
        startAddressLatLng: null,
        endAddress: null
    };

    Maps.init = function() {
        $(function() {

        });
    };

    Maps.initMap = function () {
        Maps.pollingLocation.$pollingLocationMap = $('#polling-location-map');
        Maps.pollingLocation.$pollingLocationDirectionsPanel = $('#polling-location-directions-panel');
        Maps.pollingLocation.startAddress = Maps.pollingLocation.$pollingLocationMap.attr('data-start-address');
        Maps.pollingLocation.startAddress = Maps.pollingLocation.$pollingLocationMap.attr('data-start-address-latlng');
        Maps.pollingLocation.endAddress = Maps.pollingLocation.$pollingLocationMap.attr('data-end-address');
        Maps.pollingLocation.name = Maps.pollingLocation.$pollingLocationMap.attr('data-location-name');

        if (Maps.pollingLocation.$pollingLocationMap && Maps.pollingLocation.$pollingLocationMap.length) {
            var directionsService = new google.maps.DirectionsService;
            var directionsDisplay = new google.maps.DirectionsRenderer;
            var map = new google.maps.Map(Maps.pollingLocation.$pollingLocationMap[0], {
                zoom: 7,
                center: Maps.pollingLocation.startAddressLatLng,
                scrollwheel: false
            });

            //directionsDisplay.setPanel(Maps.pollingLocation.$pollingLocationDirectionsPanel[0]);
            directionsDisplay.setMap(map);

            Maps.calculateAndDisplayRoute(directionsService, directionsDisplay, map);
        }
    };

    Maps.calculateAndDisplayRoute = function (directionsService, directionsDisplay, map) {
        directionsService.route({
            origin: Maps.pollingLocation.startAddress,
            destination: Maps.pollingLocation.endAddress,
            travelMode: google.maps.TravelMode.DRIVING
        }, function(response, status) {
            if (status === google.maps.DirectionsStatus.OK) {
                directionsDisplay.setDirections(response);
                console.log(response);

                var endLocation = response.routes[0].legs[0].end_location;
                var endLatLng = new google.maps.LatLng(endLocation.lat(), endLocation.lng());

                var infowindow = new google.maps.InfoWindow({
                    content: Maps.pollingLocation.name
                });

                var marker = new google.maps.Marker({
                    position: endLatLng,
                    map: map,
                    title: 'Uluru (Ayers Rock)'
                });
                infowindow.open(map, marker);
            } else {
                window.alert('Directions request failed due to ' + status);
            }
        });
    };

    return Maps;
};

export default Maps;
